import React from 'react';

export const Overlay = ({ overlay, statusClass }: { overlay: any, statusClass: string }) => {
  return <div className={`overlay ${statusClass}`} dangerouslySetInnerHTML={{ __html: overlay.contents.html }} />;
};

export default Overlay;
